export const DEBUG_PREAUTORISATION = {
  id: '11111111-bbbb-0000-aaaa-000000000',
  emploi: {
    revenuAnnuelBrut: 45000
  },
  coordonnees: {
    idStatusResidence: '2',
    numeroCivique: '1900',
    rue: "Av De l'Église",
    typeUnite: 'APP',
    unite: '3',
    ville: 'Montréal',
    territoire: 'QC',
    pays: 'CA',
    codePostal: 'H4E1G8',
    adresseFormattee: "3-1900 Av De l'Église, MONTRÉAL QC H4E 1G8, CANADA",
    dateDebutResidence: '2018-03-01T05:00:00.000Z',
    courriel: 'une.adresse@courriel.com',
    numeroTelephone: '5142857321'
  },
  nbrLogements: 2,
  montantPropriete: 324234,
  miseDeFonds: 44444,
  type: 'PME_REMPLACER',
  courrielCoemprunteur: 'coemprunteur2@desjardins.com',
  prenomCoemprunteur: 'Stuby',
  nomCoemprunteur: 'Stub',
  codeInvitation: 'ACB1234',
  codeExpiration: '2019-02-26T08:27:12Z',
  dateExpirationSelectionTaux: '2019-02-26T08:27:12Z',
  resultat: {
    dateDecision: '2019-02-26T08:27:12Z',
    dateExpiration: '2022-02-01T00:00:00Z',
    dateExpirationContreOffre: '2022-02-01T00:00:00Z',
    montantContreOffre: 260000,
    taux: [
      {
        idOffreTarificationBancaire: 'ebfbed9a-865e-43e9-8ccb-b9ffcf5d8ee3',
        idRepertoireProduitTerme: 'fdc8ad95-bf53-49bf-b51a-e8edcadd25eb',
        tauxPersonnalise: 3.59,
        dateExpirationGarantieTaux: '2022-07-07T00:00:00Z',
        tauxPreferentielCourant: 2.45,
        valEcartPersonnalise: null,
        indSelectionMembre: true,
        indPromotion: false,
        sousTypeTaux: 'FIXE_REGULIER',
        nbrUniteTerme: 5,
        frequenceTerme: 'ANS'
      },
      {
        idOffreTarificationBancaire: 'ef221fa3-308b-4751-93d5-3e92bf41e169',
        idRepertoireProduitTerme: '881ff5ff-bdcb-4ae4-8826-0bb51b9fbced',
        tauxPersonnalise: 3.49,
        dateExpirationGarantieTaux: '2022-08-01T00:00:00Z',
        tauxPreferentielCourant: 2.45,
        valEcartPersonnalise: null,
        indSelectionMembre: false,
        indPromotion: true,
        sousTypeTaux: 'FIXE_REGULIER',
        nbrUniteTerme: 40,
        frequenceTerme: 'MOIS'
      },
      {
        idOffreTarificationBancaire: 'f1d1d2d0-86c1-40be-a4c4-949e6b9a9128',
        idRepertoireProduitTerme: '7d397702-99ef-4fff-9e0e-22a5a52974ae',
        tauxPersonnalise: 3.39,
        dateExpirationGarantieTaux: '2022-07-07T00:00:00Z',
        tauxPreferentielCourant: 2.45,
        valEcartPersonnalise: null,
        indSelectionMembre: false,
        indPromotion: false,
        sousTypeTaux: 'FIXE_REGULIER',
        nbrUniteTerme: 3,
        frequenceTerme: 'ANS'
      },
      {
        idOffreTarificationBancaire: '27d64dc9-ee3c-4270-9907-4c5318c3ab50',
        idRepertoireProduitTerme: '48811eb4-5766-4bc1-91ec-93478d0f9ffb',
        tauxPersonnalise: 1.8,
        dateExpirationGarantieTaux: '2022-07-07T00:00:00Z',
        tauxPreferentielCourant: 2.45,
        valEcartPersonnalise: -0.65,
        descriptionFrancaise: 'Taux 5 ans variable réduit',
        descriptionAnglaise: '5-year reduced variable rate',
        indSelectionMembre: false,
        indPromotion: false,
        sousTypeTaux: 'VARIABLE_REDUIT',
        nbrUniteTerme: 5,
        frequenceTerme: 'ANS'
      }
    ]
  }
};
